import React, { useState } from "react";
import { isValidPhoneNumber } from "react-phone-number-input";
import Input from "components/Input";

function ReserveForm(props) {
  const createRes = props.createRes;
  const [name, setName] = useState(null);
  const [notes, setNotes] = useState(null);
  const [phone, setPhone] = useState("+1");
  const [consent, setConsent] = useState(false);
  const [errorStates, setError] = useState({
    name: false,
    phone: false,
    consent: false,
  });

  const inputText = {
    name: errorStates.name ? "Enter your name" : "Name",
    phone: errorStates.phone ? "Enter a valid phone number" : "Phone Number",
    message: "Additional Notes?",
  };

  const handlePhoneChange = (value) => {
    setPhone(value);
    setError((errorStates) => ({ ...errorStates, phone: false }));
  };

  const handleChange = (event) => {
    if (event.target.id === "name") {
      setError((errorStates) => ({ ...errorStates, name: false }));
      setName(event.target.value);
    }
    if (event.target.id === "message") {
      setNotes(event.target.value);
    }
  };

  const onSubmit = () => {
    if (!reserveValidator()) createRes({ name, phone, notes, sendText: consent });
  };

  const inputObjs = {
    name: {
      name: "name",
      id: "name",
      text: inputText.name,
      error: errorStates.name,
      handleChange,
    },
    phone: {
      name: "phone",
      type: "phone",
      text: inputText.phone,
      error: errorStates.phone,
      value: phone,
      handleChange: handlePhoneChange,
    },
    message: {
      name: "message",
      id: "message",
      type: "textarea",
      text: inputText.message,
      handleChange,
    },
  };

  const reserveValidator = () => {
    let isError = false;
    if (!name) {
      setError((errorStates) => ({ ...errorStates, name: true }));
      isError = true;
    }
    if (!phone || phone === "+1" || !isValidPhoneNumber(phone)) {
      isError = true;
      setError((errorStates) => ({ ...errorStates, phone: true }));
    }
    if (!consent) {
      isError = true;
      setError((errorStates) => ({ ...errorStates, consent: true }));
    }
    return isError;
  };

  return (
    <>
      <div>
        <div className="row flex-end mobile" style={{ paddingBottom: "0px" }}>
          {Input(inputObjs.name)}
          {Input(inputObjs.phone)}
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            paddingTop: "15px",
          }}
        >
          <span className="reserve-small-text">
            {" "}
            • A confirmation text will be sent upon reserving. If you do not
            receive a text, please call the restaurant to confirm your
            reservation.
          </span>
        </div>
      </div>
      <div>
        {Input(inputObjs.message)}
        <div className="reserve-small-text" style={{ paddingTop: "15px" }}>
          • Please note, outdoor seating is first come first serve.
        </div>
      </div>
      {errorStates.consent && (
        <div style={{ color: "var(--red)", fontSize: "14px", fontWeight: "500", marginBottom: "-30px" }}>
          Please agree to receive text messages to continue
        </div>
      )}
      <div
        className="consent-checkbox-container"
        style={{
          display: "flex",
          alignItems: "flex-start",
          gap: "10px",
          padding: "15px 0",
          borderTop: errorStates.consent
            ? "1px solid var(--red)"
            : "1px solid #e0e0e0",
          marginTop: "15px",
        }}
      >
        <input
          type="checkbox"
          id="consent-checkbox"
          checked={consent}
          onChange={(e) => {
            setConsent(e.target.checked);
            setError((errorStates) => ({ ...errorStates, consent: false }));
          }}
          style={{
            marginTop: "3px",
            cursor: "pointer",
            accentColor: "#333",
          }}
        />
        <label
          htmlFor="consent-checkbox"
          style={{
            fontSize: "12px",
            lineHeight: "1.2",
            cursor: "pointer",
            fontWeight: "500",
            color: "rgba(71, 71, 71, 0.67)",
          }}
        >
          {`I consent to receive automated text messages from Trattoria Demi regarding my reservation. 
          Message frequency varies based on reservation activity. Message and data rates may apply. Reply HELP for help or STOP to cancel. `}
          <span
            className="legal-link"
            onClick={(e) => {
              e.preventDefault();
            }}
            style={{
              color: "#0066cc",
              textDecoration: "underline",
              cursor: "pointer",
            }}
          >
            Privacy Policy
          </span>
          {" and "}
          <span
            className="legal-link"
            onClick={(e) => {
              e.preventDefault();
            }}
            style={{
              color: "#0066cc",
              textDecoration: "underline",
              cursor: "pointer",
            }}
          >
            Terms of Service
          </span>
        </label>
      </div>

      <button className="submit-button" type="button" onClick={onSubmit}>
        Reserve
      </button>
    </>
  );
}

export default ReserveForm;
